import { render, staticRenderFns } from "./VoipEdit.vue?vue&type=template&id=0a4a9554&scoped=true&"
import script from "./VoipEdit.vue?vue&type=script&lang=js&"
export * from "./VoipEdit.vue?vue&type=script&lang=js&"
import style0 from "./VoipEdit.vue?vue&type=style&index=0&id=0a4a9554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4a9554",
  null
  
)

export default component.exports